import { render, staticRenderFns } from "./reply.vue?vue&type=template&id=261df0c0&scoped=true&"
import script from "./reply.vue?vue&type=script&lang=js&"
export * from "./reply.vue?vue&type=script&lang=js&"
import style0 from "./reply.vue?vue&type=style&index=0&id=261df0c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261df0c0",
  null
  
)

export default component.exports